<template>
    <div>
        <div class="ap-workspace-head">
            <div class="ap-workspace-label">
                <div class="ap-workspace-label-name">
                    Организации
                </div>
                <div class="ap-workspace-label-btn" v-on:click="addOrganization()">
                    <SVGPlus/>
                </div>
            </div>
            <div class="ap-workspace-label-btn ap-add-left-margin">
                <label class="ap-search">
                    <input type="text" class="ap-search-input" placeholder="Найти организацию" v-model="mask">
                </label>
            </div>
        </div>
        <vue-custom-scrollbar @ps-y-reach-end="scrollReachEnd">
        <div class="ap-workspace-table-container">
            <table class="result-table">
                <thead>
                <tr class="head-tr">
                    <th>№</th>
                    <th>Название</th>
                    <th>Тип</th>
                    <th>Телефон</th>
                    <th>Описание</th>
                    <th class="field-edit">Опции</th>
                </tr>
                </thead>
                <tbody>
                <tr class="body-tr row" v-for="value in organizations">
<!--                    <td>-->
<!--                        <span class="table-data-central">{{value.id}}</span>-->
<!--                    </td>-->
                    <td>
                        <span class="table-data">{{value.id}}</span>
                    </td>
                    <td>
                        <span class="table-data">{{value.name}}</span>
                    </td>
                    <td>
                        <span class="table-data">{{value.type}}</span>
                    </td>
                    <td>
                        <span class="table-data">{{value.phone}}</span>
                    </td>
                    <td>
                        <span class="table-data">{{value.description}}</span>
                    </td>
                    <td>
                        <div class="edit-button-group">
                            <div class="table-svg-button" v-on:click="editOrganization(value)">
                                <SVGAdminEditRow/>
                            </div>
                            <div class="table-svg-button" v-on:click="confirm(value)">
                                <SVGAdminDeleteRow/>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="waitingResponseToOrganizationsRequest" class="ap-loader-grid">
                <SpinnerTwo/>
                <div class="ap-loader-text">
                    Идет загрузка организаций ...
                </div>
            </div>
        </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow.vue";
    import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow.vue";
    import SVGPlus from "../../SVG/SVGPlus";
    import {modalMethods, urlForStaticVue} from "../../common";
    import SVGSearch from "../../SVG/SVGSearch";
    import SpinnerTwo from "../../SpinnerTwo";
    import ModalConfirmation from "../../Modal/ModalConfirmation";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import AddOrganization from "../../Modal/AdminPage/OrganizationsPage/AddOrganization";
    import EditOrganization from "../../Modal/AdminPage/OrganizationsPage/EditOrganization";

    export default {
        name: "AdminOrganizations",
        mixins: [urlForStaticVue, modalMethods],
        components: {
            SpinnerTwo,
            SVGSearch,
            SVGPlus,
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            vueCustomScrollbar
        },
        methods: {
            deleteRow(organizationID) {
                return () => {this.$store.dispatch('adminPanel/organizations/DELETE_ORGANIZATION', organizationID)};
            },
            confirm(organization) {
                const title = `Удалить организацию "${organization.name}"?`
                const text = 'Запись о данной организации будет безвозвратно удалена, хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteRow(organization.id)}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            editOrganization(organizationData) {
                this.$modal.show(EditOrganization, {organizationData}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 480,
                    draggable: true,
                });
            },
            addOrganization() {
                this.$modal.show(AddOrganization, {}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 480,
                    draggable: true,
                });
            },
            scrollReachEnd(){
                // this.$store.dispatch('adminPanel/organizations/GET_ORGANIZATIONS');
            }
        },
        data(){
            return {
                timerId: null
            }
        },
        computed: {
            waitingResponseToOrganizationsRequest() {
                return this.$store.state.adminPanel.organizations.waitingResponseToOrganizationRequest;
            },
            organizations(){
                return this.$store.getters["adminPanel/organizations/SELF"];
            },
            mask:{
                get(){
                    return this.$store.state.adminPanel.organizations.mask;
                },
                set(value){
                    this.$store.commit('adminPanel/organizations/MASK', value);
                    // if (this.timerId) {
                    //     clearTimeout(this.timerId);
                    //     this.timerId = null;
                    // }
                    // this.timerId = setTimeout(() => {
                    //     this.$store.commit('adminPanel/organizations/CLEAR_ORGANIZATIONS');
                    //     this.$store.dispatch('adminPanel/organizations/GET_ORGANIZATIONS');
                    //     this.timerId = null;
                    // }, 500);
                }
            }
        },
        mounted() {
            this.$store.dispatch('adminPanel/organizations/GET_ORGANIZATIONS');
        },
        destroyed() {
            this.$store.commit('adminPanel/organizations/CLEAR_ORGANIZATIONS');
        }
    }
</script>

<style scoped>

</style>
